import { useState, FC } from 'react';
import { ForgotPasswordSchema } from './types';
import { forgotPasswordSchemaValidation } from './forgotPasswordValidation';
import { forgotPasswordSchema as formSchema } from './forgotPasswordSchema'
import { ButtonSubmit, FormAlert } from 'components';
import { useAppDispatch } from 'lib/redux';
import { resetAccountPassword } from '../accountSlice';
import {
  Box,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
} from "@chakra-ui/react";
import { Field, FieldProps, Formik, Form } from "formik";
import { v4 as uuid } from "uuid";
import { getIcon } from "lib/icons";

type OnSubmit = (values: ForgotPasswordSchema, actions: any) => void;

type State = {
  error: string;
  success: string;
}

const DEFAULT_ERROR = 'There was an error, please try again';

const initialState = { error: '', success: '' };

export const ForgotPasswordForm: FC<any> = () => {
  const dispatch = useAppDispatch();
  const [ state, setState ] = useState<State>(initialState);

  const onSubmit: OnSubmit = async ({ email }, { resetForm }) => {
    try {
      setState({ ...initialState });

      await dispatch(resetAccountPassword({ email })).unwrap();
      setState({ ...state, success: 'You will recieve an email if this address exists in our systems.' });
      resetForm();
    } catch (err) {
      setState({ ...state, error: DEFAULT_ERROR });
    }
  }

  return (
    <Box width={"100%"}>
      <Formik
        initialValues={{ email: '' }}
        enableReinitialize={true}
        validationSchema={forgotPasswordSchemaValidation}
        onSubmit={onSubmit}
      >
        <Form>
          <Stack spacing={6} width="100%">
            <FormAlert success={state.success} error={state.error} />
            {formSchema.map((schema) => (
              <Field key={uuid()} name={schema.name}>
                {({field, form, meta}: FieldProps) => (
                  <FormControl
                    isInvalid={Boolean(meta.touched && form.errors[field.name])}
                    isRequired={true}
                  >
                    <InputGroup size="md">
                      <InputLeftElement height="100%" width="30px" ml="15px">
                        {getIcon(schema.icon)}
                      </InputLeftElement>
                      <Input pr="2rem" pl="4rem" size="lg"{...schema} {...field} />
                    </InputGroup>
                    <FormErrorMessage>{form.errors[field.name]}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            ))}
            <ButtonSubmit isFullWidth={true} size="xl">Send reset link</ButtonSubmit>
          </Stack>
        </Form>
      </Formik>
    </Box>
  )
}
